














































import { Vue, Component } from 'vue-property-decorator';
import axios from 'axios';
import AuthenticationService from '@/domain/security/authentication.service';
import UserSecurity from '@/domain/security/user-security.entity';
import HomeButton from '@/shared/button/button.component.vue';

@Component
export default class TaskReport extends Vue {
  private user: UserSecurity = new UserSecurity({
    userName: this.$store.getters.getUser.email,
  });

  private data: Array<any> = [];

  loading = false;

  headers = [
    {
      text: 'Data',
      sortable: false,
    },
    {
      text: 'Horas Ponto',
      sortable: false,
      align: 'right',
    },
    {
      text: 'Horas Task',
      sortable: false,
      align: 'right',
    },
    {
      text: 'Diferença',
      sortable: false,
      align: 'right',
    },
  ];

  created() {
    // this.user =
    this.loadCurrentMonth();
  }

  get totalHorasTask(): number {
    let totalHoras = 0;
    this.data.forEach((el: any) => totalHoras += el.horasTask);
    return totalHoras;
  }

  get totalHorasPonto(): number {
    let totalHoras = 0;
    this.data.forEach((el: any) => totalHoras += el.horasPonto);
    return totalHoras;
  }

  get totalDiferenca(): number {
    let totalHoras = 0;
    this.data.forEach((el: any) => totalHoras += el.diferenca);
    return totalHoras;
  }

  rowColor(value: number): string {
    return value === 0 ? 'row-color' : '';
  }

  loadCurrentMonth() {
    this.data = [];
    this.loading = true;
    axios
      .get('/auditoria/usuario/mes-atual', { params: { usuario: this.user.username } })
      .then((response: any) => this.data = response.data)
      .finally(() => (this.loading = false));
  }

  loadPreviousMonth() {
    this.data = [];
    this.loading = true;
    axios
      .get(`/auditoria/usuario/mes-anterior?usuario=${this.user.username}`)
      .finally(() => (this.loading = false))
      .then((response: any) => this.data = response.data);
  }

  formatNumber(value: number) {
    if (value) {
      return value.toFixed(2).replace('.', ',');
    }
    return '0,00';
  }
}
